var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopMenu",
    transform: "translate(-1404.000000, -15.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(1404.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,11.2 C4.91356994,11.2 2.4,8.68643006 2.4,5.6 C2.4,2.51356994 4.91356994,0 8,0 C11.0864301,0 13.6,2.51356994 13.6,5.6 C13.6,8.68643006 11.0864301,11.2 8,11.2 Z M8,1.59582463 C5.79624217,1.59582463 4.00167015,3.39039666 4.00167015,5.59415449 C4.00167015,7.79791232 5.79624217,9.59248434 8,9.59248434 C10.2037578,9.59248434 11.9983299,7.79791232 11.9983299,5.59415449 C11.9983299,3.39039666 10.2037578,1.59582463 8,1.59582463 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17.6 L14.3988313,17.6 C14.3988313,14.0704164 11.5295836,11.2011687 8,11.2011687 C4.47041636,11.2011687 1.60116874,14.0704164 1.60116874,17.6 L0,17.6 C0,13.1880205 3.58802045,9.6 8,9.6 C12.4119795,9.6 16,13.1880205 16,17.6 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f29e2de958ba4564abbcd8b1241759e5.svg";
export { ForwardRef as ReactComponent };